export default {
  pageHeader: {
    title: "Sync with external IT services",
    description:
      "You can easily import and export Device data, with seamless asynchronous syncing.",
  },
  tableHeader: {
    title: "Integrated IT service",
    addIntegration: "Add integration",
  },
  actionsColumn: {
    sync: "Sync",
    syncStarted: "Sync started!",
  },
  syncResultColumn: {
    allSuccess: "All Success",
    partialError: "Partial Error",
  },
  preview: {
    addStepperNavigation: {
      title: "Sync Result",
    },
    previewFile: {
      summaryErrorMessage:
        "Rows with errors haven't been imported, but other rows have been successfully imported. If you want to import the errored rows, please correct the source data.",
    },
  },
  dialogAlert: {
    title: "Syncing the Device data: one-way import",
    description:
      "This action could delete data permanently and cannot be undone.",
    subDescription1:
      "One-way import allows data to be brought in from an external source.",
    subDescription2:
      "The incoming data replaces any existing data in the system.",
    okLabel: "Start sync",
  },
};
